import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { beforeRenewEnabled } from 'reactApp/appHelpers/featuresHelpers/features/beforeRenewModal';
import type { BillingDataSubscriptionInfo } from 'reactApp/modules/billingData/billingData.types';
import { isSubscriptionRenewable } from 'reactApp/modules/billingData/billingData.utils';
import { closeBeforeRenewModal, renderBeforeRenewModal } from 'reactApp/ui/BeforeRenewModal/BeforeRenewModal.helpers';
import { captureException } from 'reactApp/utils/tracer';
import { channel } from 'redux-saga';
import { take } from 'redux-saga/effects';

export function needShowBeforeRenewModal(subscription: BillingDataSubscriptionInfo) {
    const { grace } = subscription;
    const isRenewable = isSubscriptionRenewable(subscription, true);
    return beforeRenewEnabled && !grace && isRenewable;
}

export function* openBeforeRenewModal(subscription: BillingDataSubscriptionInfo) {
    if (needShowBeforeRenewModal(subscription)) {
        const modalChannel = channel();
        try {
            renderBeforeRenewModal({
                subscription,
                onShow() {
                    emitAnalyticEvent(AnalyticEventNames.BEFORE_RENEW_MODAL_SHOW);
                },
                onClick() {
                    modalChannel.put(true);
                    closeBeforeRenewModal();
                    emitAnalyticEvent(AnalyticEventNames.BEFORE_RENEW_MODAL_CLICK);
                },
                onCancel() {
                    modalChannel.put(false);
                    closeBeforeRenewModal();
                    emitAnalyticEvent(AnalyticEventNames.BEFORE_RENEW_MODAL_CANCEL);
                },
                onClose() {
                    modalChannel.put(false);
                    emitAnalyticEvent(AnalyticEventNames.BEFORE_RENEW_MODAL_CLOSE);
                },
            });

            return yield take(modalChannel);
        } catch (error) {
            captureException(error, { issueKey: `openBeforeRenewModal/error` });
        } finally {
            modalChannel.close();
        }
    }
    return isSubscriptionRenewable(subscription, true);
}
